import { Box, useBreakpointValue } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { HeaderDesktop } from "./Desktop";
import { HeaderSearch } from "./Search";
import { HeaderMobile } from "./Mobile";

export function Header() {
  const [isSearchOpened, setIsSearchOpened] = useState(false);

  const router = useRouter();

  const isMobile = useBreakpointValue({ base: true, lg: false });

  useEffect(() => {
    if (isMobile) {
      setIsSearchOpened(false);
    }
  }, [isMobile]);

  useEffect(() => {
    const handleRouteChange = () => {
      setIsSearchOpened(false);
    };

    router.events.on("routeChangeStart", handleRouteChange);
    router.events.on("hashChangeStart", handleRouteChange);
    return () => {
      router.events.off("routeChangeStart", handleRouteChange);
      router.events.off("hashChangeStart", handleRouteChange);
    };
  }, [router, setIsSearchOpened]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsSearchOpened(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setIsSearchOpened]);

  return (
    <Box alignSelf="flex-start" marginBottom="-18px">
      <HeaderDesktop setIsSearchOpened={setIsSearchOpened} />

      <HeaderMobile />

      <HeaderSearch
        isSearchOpened={isSearchOpened}
        setIsSearchOpened={setIsSearchOpened}
      />
    </Box>
  );
}
